export default "__VITE_ASSET__$kpN0ucb__"